module.exports = __webpack_public_path__ + "img/3.b1c45ce4.jpg";